import { emptySplitApi } from './index'

export const letterHeadApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    saveLetterHead: builder.mutation({
      query: ({sharedLetterHeadType, model}) => ({
        url: `api/v1/auth-service/letter-head/${sharedLetterHeadType}`,
        method: "POST",
        body: model,
      }),
      invalidatesTags: ["LetterHead"],
    }),
    getLetterHead: builder.mutation({
      query: ({ customDocumentType, userProjectId }) => ({
        url: `api/v1/document-generator-service/document-format-settings/${encodeURIComponent(customDocumentType)}/${encodeURIComponent(userProjectId)}`,
        method: "GET",
      }),
    }),
    getLetterHead1: builder.mutation({
      query: (sharedLetterHeadType) => ({
        url: `api/v1/auth-service/letter-head/${sharedLetterHeadType}`,
        method: "GET",
      }),
    }),
    getLetterHead2: builder.query({
      query: (sharedLetterHeadType) => ({
        url: `api/v1/auth-service/letter-head/${sharedLetterHeadType}`,
        method: "GET",
      }),
      providesTags: ["LetterHead"],
    }),
    saveLetterHeadFooterOnly: builder.mutation({
        query: ({ letterType, customDocumentType, userProjectId }) => ({
            url: `api/v1/document-generator-service/document-format-settings/${letterType}/${customDocumentType}/${userProjectId}`,
            method: "POST",
        }),
    }),
  }),
  overrideExisting: false,
});

export const { 
    useSaveLetterHeadMutation, 
    useGetLetterHeadMutation,
    useGetLetterHead1Mutation,
    useGetLetterHead2Query,
    useSaveLetterHeadFooterOnlyMutation
} = letterHeadApi;
